import React from "react"
import { Link } from 'gatsby'

export default () => {
    const year = new Date().getFullYear()
    return (
        <div className="layout dark">
            <div className="layout__container">
                <div className="layout__wide copyright center">
                    <p>&copy; {year} &nbsp; • &nbsp; <Link to='/terms/'>Terms</Link> &nbsp; • &nbsp; <Link to='/privacy/'>Privacy</Link> &nbsp; • &nbsp; 11b/524 Remuera Road, Remuera, Auckland &nbsp; • &nbsp; <a href="https://www.facebook.com/TheGreenRoomHairStudio" rel="nofollow noreferrer" target="_blank">Facebook</a></p>
                </div>
            </div>
        </div>
    )
}